import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../App';
import { toast } from 'sonner';
import { Loader2, XCircle } from 'lucide-react';

export default function SSOCallbackPage() {
  const { setAuth } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get('code');
    const errDesc = params.get('error_description');
    if (errDesc) { setError(errDesc); return; }
    if (!code) { setError('No authorization code returned by Microsoft.'); return; }
    axios.post(`${API}/auth/sso/callback`, { code, redirect_uri: `${window.location.origin}/sso/callback` })
      .then(({ data }) => {
        setAuth(data);
        toast.success(`Signed in via Microsoft as ${data.user.full_name}`);
        nav('/', { replace: true });
      })
      .catch(e => setError(e?.response?.data?.detail || 'SSO sign-in failed'));
  }, [params, setAuth, nav]);

  return (
    <div className="min-h-screen grain flex items-center justify-center" data-testid="sso-callback-page">
      <div className="text-center max-w-md px-6">
        {error ? (
          <>
            <XCircle size={28} className="text-red-400 mx-auto mb-4" />
            <div className="text-white text-[15px] mb-2">Microsoft sign-in failed</div>
            <div className="text-slate-400 text-[13px] mb-6" data-testid="sso-error">{error}</div>
            <button onClick={() => nav('/login', { replace: true })} className="btn-primary">
              Back to sign in
            </button>
          </>
        ) : (
          <>
            <Loader2 size={28} className="animate-spin text-[#C17F59] mx-auto mb-4" />
            <div className="text-white text-[15px]">Completing Microsoft Entra sign-in…</div>
          </>
        )}
      </div>
    </div>
  );
}
